/* SatyShiv collection page, shop-rail filters (12 Sep). Client-side over the rendered cards; state in the URL. */
(function () {
  var root = document.querySelector('[data-sec="collection"].col2'); if (!root) return;
  var items = [].slice.call(root.querySelectorAll('.col2-item'));
  var typeBtns = [].slice.call(root.querySelectorAll('[data-col2-type]')), fragBtns = [].slice.call(root.querySelectorAll('[data-col2-frag]'));
  var showing = root.querySelector('[data-col2-showing]'), empty = root.querySelector('[data-col2-empty]'), clears = [].slice.call(root.querySelectorAll('[data-col2-clear]'));
  var q = new URLSearchParams(location.search);
  var state = { type: q.get('type') || (q.get('mood') === 'gifting' ? 'packs' : 'all'), frag: q.get('frag') || 'all' };
  if (!typeBtns.some(function (b) { return b.getAttribute('data-col2-type') === state.type; })) state.type = 'all';
  if (!fragBtns.some(function (b) { return b.getAttribute('data-col2-frag') === state.frag; })) state.frag = 'all';
  /* data-type and data-frag are space-separated lists: a combo pack is "agarbatti packs" and both its fragrances */
  function has(it, attr, k) { return (' ' + (it.getAttribute(attr) || '') + ' ').indexOf(' ' + k + ' ') >= 0; }
  function match(it, type, frag) {
    return (type === 'all' || has(it, 'data-type', type)) && (frag === 'all' || has(it, 'data-frag', frag));
  }
  function count(type, frag) { return items.filter(function (it) { return match(it, type, frag); }).length; }
  function render(push) {
    var n = 0;
    items.forEach(function (it) { var on = match(it, state.type, state.frag); it.hidden = !on; if (on) n++; });
    if (showing) showing.textContent = n;
    if (empty) empty.hidden = n > 0;
    typeBtns.forEach(function (b) {
      var k = b.getAttribute('data-col2-type'), c = count(k, state.frag), total = count(k, 'all');
      b.setAttribute('aria-pressed', k === state.type ? 'true' : 'false');
      var em = b.querySelector('[data-col2-n]'); if (em) em.textContent = c;
      b.hidden = k !== 'all' && total === 0;
    });
    fragBtns.forEach(function (b) {
      var k = b.getAttribute('data-col2-frag'), c = count(state.type, k), total = count('all', k);
      b.setAttribute('aria-pressed', k === state.frag ? 'true' : 'false');
      var em = b.querySelector('[data-col2-n]'); if (em) em.textContent = c;
      b.hidden = k !== 'all' && total === 0;
    });
    var typeGroup = root.querySelector('[data-col2-group="type"]');
    if (typeGroup) typeGroup.hidden = typeBtns.filter(function (b) { return !b.hidden; }).length < 3;
    var active = state.type !== 'all' || state.frag !== 'all';
    clears.forEach(function (c) { if (c.classList.contains('col2-clear')) c.hidden = !active; });
    if (push) {
      var u = new URL(location.href); u.searchParams.delete('mood');
      if (state.type === 'all') u.searchParams.delete('type'); else u.searchParams.set('type', state.type);
      if (state.frag === 'all') u.searchParams.delete('frag'); else u.searchParams.set('frag', state.frag);
      history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    }
  }
  typeBtns.forEach(function (b) { b.addEventListener('click', function () { state.type = b.getAttribute('data-col2-type'); if (count(state.type, state.frag) === 0) state.frag = 'all'; render(true); }); });
  fragBtns.forEach(function (b) { b.addEventListener('click', function () { state.frag = b.getAttribute('data-col2-frag'); if (count(state.type, state.frag) === 0) state.type = 'all'; render(true); }); });
  clears.forEach(function (c) { c.addEventListener('click', function () { state.type = 'all'; state.frag = 'all'; render(true); }); });
  /* sort (16 Sep): reorders the rendered cards, the filters keep working over them */
  var sortEl = root.querySelector('[data-col2-sort]'), grid = root.querySelector('[data-col2-grid]');
  if (sortEl && grid) sortEl.addEventListener('change', function () {
    var k = sortEl.value, num = function (it, a) { return parseFloat(it.getAttribute(a)) || 0; };
    var sorted = items.slice().sort(function (a, b) {
      if (k === 'price-asc') return num(a, 'data-price') - num(b, 'data-price');
      if (k === 'price-desc') return num(b, 'data-price') - num(a, 'data-price');
      if (k === 'name') return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '');
      return num(a, 'data-pos') - num(b, 'data-pos');
    });
    sorted.forEach(function (it) { grid.appendChild(it); });
  });
  render(false);
  document.addEventListener('shopify:section:load', function () { render(false); });
})();
